var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "booking-extension") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-1641.000000, -105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "booking-extension",
    transform: "translate(1641.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 455,
    cy: 244,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "Creative_line_a5",
    transform: "translate(100.000000, 95.000000)",
    stroke: "#000000",
    strokeWidth: 18.1818182
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.545455,154.517857 L254.545455,27.2678571 C254.545455,12.2069107 242.336364,0 227.272727,0 L27.2727273,0 C12.2090909,0 0,12.2069107 0,27.2678571 L0,73.8777143 C0,83.2760357 7.61818182,90.8928571 17.0181818,90.8928571 C22.1363636,90.8928571 26.8272727,88.4478393 30.2,84.6030714 C36.6272727,77.2498393 45.1363636,72.7142857 54.5454545,72.7142857 C74.6272727,72.7142857 90.9090909,93.0651964 90.9090909,118.160714 C90.9090909,143.256232 74.6272727,163.607143 54.5454545,163.607143 C45.1363636,163.607143 36.6272727,159.071589 30.2,151.718357 C26.8272727,147.873589 22.1363636,145.428571 17.0181818,145.428571 C7.61818182,145.428571 0,153.045393 0,162.443714 L0,209.053571 C0,224.114518 12.2090909,236.321429 27.2727273,236.321429 L82.9818182,236.321429 C92.3818182,236.321429 100,243.93825 100,253.336571 C100,258.453839 97.5545455,263.143911 93.7090909,266.516036 C86.3545455,272.942161 81.8181818,281.449732 81.8181818,290.857143 C81.8181818,310.935375 102.172727,327.214286 127.272727,327.214286 C152.372727,327.214286 172.727273,310.935375 172.727273,290.857143 C172.727273,281.449732 168.190909,272.942161 160.836364,266.516036 C156.990909,263.143911 154.545455,258.453839 154.545455,253.336571 C154.545455,243.93825 162.163636,236.321429 171.563636,236.321429 L209.090909,236.321429",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.9090909,
    y1: 427.196429,
    x2: 90.9090909,
    y2: 390.839286,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.9090909,
    y1: 499.910714,
    x2: 90.9090909,
    y2: 463.553571,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.090909,
    y1: 445.375,
    x2: 136.363636,
    y2: 445.375,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.7272727,
    y1: 445.375,
    x2: 45.4545455,
    y2: 445.375,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.545455,
    y1: 36.3571429,
    x2: 454.545455,
    y2: 0,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.545455,
    y1: 109.071429,
    x2: 454.545455,
    y2: 72.7142857,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.727273,
    y1: 54.5357143,
    x2: 500,
    y2: 54.5357143,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 436.363636,
    y1: 54.5357143,
    x2: 409.090909,
    y2: 54.5357143,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.636364,181.785714 L407.927273,181.785714 C398.527273,181.785714 390.909091,174.168893 390.909091,164.770571 C390.909091,159.653304 393.354545,154.963232 397.2,151.591107 C404.554545,145.164982 409.090909,136.657411 409.090909,127.25 C409.090909,107.171768 388.736364,90.8928571 363.636364,90.8928571 C338.536364,90.8928571 318.181818,107.171768 318.181818,127.25 C318.181818,136.657411 322.718182,145.164982 330.072727,151.591107 C333.918182,154.963232 336.363636,159.653304 336.363636,164.770571 C336.363636,174.168893 328.745455,181.785714 319.345455,181.785714 L263.636364,181.785714 C248.572727,181.785714 236.363636,193.992625 236.363636,209.053571 L236.363636,255.663429 C236.363636,265.06175 243.981818,272.678571 253.381818,272.678571 C258.5,272.678571 263.190909,270.233554 266.563636,266.388786 C272.990909,259.035554 281.5,254.5 290.909091,254.5 C310.990909,254.5 327.272727,274.850911 327.272727,299.946429 C327.272727,325.041946 310.990909,345.392857 290.909091,345.392857 C281.5,345.392857 272.990909,340.857304 266.563636,333.504071 C263.190909,329.659304 258.5,327.214286 253.381818,327.214286 C243.981818,327.214286 236.363636,334.831107 236.363636,344.229429 L236.363636,390.839286 C236.363636,405.900232 248.572727,418.107143 263.636364,418.107143 L319.345455,418.107143 C328.745455,418.107143 336.363636,425.723964 336.363636,435.122286 C336.363636,440.239554 333.918182,444.929625 330.072727,448.30175 C322.718182,454.727875 318.181818,463.235446 318.181818,472.642857 C318.181818,492.721089 338.536364,509 363.636364,509 C388.736364,509 409.090909,492.721089 409.090909,472.642857 C409.090909,463.235446 404.554545,454.727875 397.2,448.30175 C393.354545,444.929625 390.909091,440.239554 390.909091,435.122286 C390.909091,425.723964 398.527273,418.107143 407.927273,418.107143 L463.636364,418.107143 C478.7,418.107143 490.909091,405.900232 490.909091,390.839286 L490.909091,344.229429 C490.909091,334.831107 483.290909,327.214286 473.890909,327.214286 C468.772727,327.214286 464.081818,329.659304 460.709091,333.504071 C454.281818,340.857304 445.772727,345.392857 436.363636,345.392857 C416.281818,345.392857 400,325.041946 400,299.946429 C400,274.850911 416.281818,254.5 436.363636,254.5 C445.772727,254.5 454.281818,259.035554 460.709091,266.388786 C464.081818,270.233554 468.772727,272.678571 473.890909,272.678571 C483.290909,272.678571 490.909091,265.06175 490.909091,255.663429 L490.909091,209.053571 C490.909091,193.992625 478.7,181.785714 463.636364,181.785714 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.41e42e5f5d5e05c50a9019a4182f6284.svg";
export { ForwardRef as ReactComponent };